<script setup lang="ts">
const { t } = useI18n()

definePageMeta({
  nameKey: 'game-dungeon-guide',
  head: {
    imageUrl: '/images/view/game/dungeon-explorer/guide/meta_preview.png'
  }
})

const weaponTips = [
  {
    icon: 'hammer',
    title: t('jc.view.dungeon.guide.weapons.anvil.title'),
    text:  t('jc.view.dungeon.guide.weapons.anvil.text'),
  },
  {
    icon: 'gift',
    title: t('jc.view.dungeon.guide.weapons.loot.title'),
    text:  t('jc.view.dungeon.guide.weapons.loot.text'),
  },
  {
    icon: 'arrow-trend-up',
    title: t('jc.view.dungeon.guide.weapons.priority.title'),
    text:  t('jc.view.dungeon.guide.weapons.priority.text'),
  },
  {
    icon: 'wallet',
    title: t('jc.view.dungeon.guide.weapons.save.title'),
    text:  t('jc.view.dungeon.guide.weapons.save.text'),
  },
  {
    icon: 'arrow-up',
    title: t('jc.view.dungeon.guide.weapons.level_anyway.title'),
    text:  t('jc.view.dungeon.guide.weapons.level_anyway.text'),
  },
  {
    icon: 'store',
    title: t('jc.view.dungeon.guide.weapons.shop.title'),
    text:  t('jc.view.dungeon.guide.weapons.shop.text'),
  }
]

const combatTips = [
  {
    icon: 'shield-check',
    title: t('jc.view.dungeon.guide.combat.patterns.title'),
    text:  t('jc.view.dungeon.guide.combat.patterns.text'),
  },
  {
    icon: 'bow-arrow',
    title: t('jc.view.dungeon.guide.combat.bow.title'),
    text:  t('jc.view.dungeon.guide.combat.bow.text'),
  },
  {
    icon: 'person-running-fast',
    title: t('jc.view.dungeon.guide.combat.movement.title'),
    text:  t('jc.view.dungeon.guide.combat.movement.text'),
  },
  {
    icon: 'empty-set',
    title: t('jc.view.dungeon.guide.combat.dodge.title'),
    text:  t('jc.view.dungeon.guide.combat.dodge.text'),
  },
  {
    icon: 'battery-bolt',
    title: t('jc.view.dungeon.guide.combat.charge.title'),
    text:  t('jc.view.dungeon.guide.combat.charge.text'),
  },
  {
    icon: 'refresh',
    title: t('jc.view.dungeon.guide.combat.flex.title'),
    text:  t('jc.view.dungeon.guide.combat.flex.text'),
  },
  {
    icon: 'cloud-rain',
    title: t('jc.view.dungeon.guide.combat.aoe.title'),
    text:  t('jc.view.dungeon.guide.combat.aoe.text'),
  },
  {
    icon: 'zap',
    title: t('jc.view.dungeon.guide.combat.synergy.title'),
    text:  t('jc.view.dungeon.guide.combat.synergy.text'),
  }
]

const deckTips = [
  {
    icon: 'cards-blank',
    title: t('jc.view.dungeon.guide.deck.title'),
    text:  t('jc.view.dungeon.guide.deck.text'),
  },
  {
    icon: 'unlock',
    title: t('jc.view.dungeon.guide.deck.unlock.title'),
    text:  t('jc.view.dungeon.guide.deck.unlock.text'),
  },
  {
    icon: 'lightbulb',
    title: t('jc.view.dungeon.guide.deck.daily.title'),
    text:  t('jc.view.dungeon.guide.deck.daily.text'),
  }
]

const miscTips = [
  {
    icon: 'users',
    title: t('jc.view.dungeon.guide.misc.coop.title'),
    text:  t('jc.view.dungeon.guide.misc.coop.text'),
  },
  {
    icon: 'dice-d6',
    title: t('jc.view.dungeon.guide.misc.mutators.title'),
    text:  t('jc.view.dungeon.guide.misc.mutators.text'),
  },
  {
    icon: 'credit-card',
    title: t('jc.view.dungeon.guide.misc.jaycees.title'),
    text:  t('jc.view.dungeon.guide.misc.jaycees.text'),
  },
  {
    icon: 'map',
    title: t('jc.view.dungeon.guide.misc.dungeons.title'),
    text:  t('jc.view.dungeon.guide.misc.dungeons.text'),
  },
  {
    icon: 'book-open',
    title: t('jc.view.dungeon.guide.misc.spells.title'),
    text:  t('jc.view.dungeon.guide.misc.spells.text'),
  }
]
</script>

<template>
  <Container>
    <HeroCard
      :heading="t('jc.view.dungeon.guide.hero.title')"
      :paragraph="t('jc.view.dungeon.guide.hero.text')"
      :image="{
        src: 'images/view/game/dungeon-explorer/guide/hero_banner.png',
        alt: t('jc.view.dungeon.guide.hero.banner.alt')
      }"
      :float="{
        src: 'images/view/game/dungeon-explorer/guide/float.png',
        alt: t('jc.view.dungeon.guide.hero.float.alt')
      }"
    />
  </Container>

  <Container id="weapons">
    <ContentCard
      :heading="t('jc.view.dungeon.guide.section.weapons.title')"
      :paragraph="''"
    >
      <IconSection :sections="weaponTips" :count="false" />
    </ContentCard>
  </Container>

  <Container id="combat">
    <ContentCard
      :heading="t('jc.view.dungeon.guide.section.combat.title')"
      :paragraph="''"
    >
      <IconSection :sections="combatTips" :count="false" />
    </ContentCard>
  </Container>

  <Container id="deck">
    <ContentCard
      :heading="t('jc.view.dungeon.guide.section.deck.title')"
      :paragraph="''"
    >
      <IconSection :sections="deckTips" :count="false" />
    </ContentCard>
  </Container>

  <Container id="misc">
    <ContentCard
      :heading="t('jc.view.dungeon.guide.section.misc.title')"
      :paragraph="''"
    >
      <IconSection :sections="miscTips" :count="false" />
    </ContentCard>
  </Container>

  <Container>
    <JoinCard
      :server="t('jc.view.dungeon.guide.hero.title')"
      :image="{ src: 'images/view/game/dungeon-explorer/guide/call_to_action_background.png' }"
    />
  </Container>
</template>

